import { type CanonicalSchema, deepFreeze, CanonicalFieldType as T } from './canonical-schema.js'

/**
 * `client@1` — owned by the customer bounded context (customer-service,
 * TO-403). One record is one partner client, matched by `externalId` within the
 * import definition's source system (never a record field, so a row cannot
 * write into another system's scope). APPEND-ONLY: never edit this published
 * version; publish `client.v2.ts` instead.
 */
export const CLIENT_V1: CanonicalSchema = deepFreeze({
	name: 'client',
	version: 1,
	owner: 'customer',
	fields: [
		{ name: 'externalId', type: T.STRING, required: true, nullable: false, maxLength: 128 },
		{ name: 'firstName', type: T.STRING, required: true, nullable: false, maxLength: 100 },
		{ name: 'lastName1', type: T.STRING, required: false, nullable: true, maxLength: 100 },
		{ name: 'lastName2', type: T.STRING, required: false, nullable: true, maxLength: 100 },
		{ name: 'type', type: T.STRING, required: false, nullable: true, maxLength: 16 },
		{ name: 'statusPartnerLabel', type: T.STRING, required: false, nullable: true, maxLength: 100 },
		{ name: 'preferredChannel', type: T.STRING, required: false, nullable: true, maxLength: 16 },
		{ name: 'preferredLocale', type: T.STRING, required: false, nullable: true, maxLength: 16 },
		{ name: 'orgUnitCode', type: T.STRING, required: true, nullable: false, maxLength: 64 },
		{ name: 'assignedUserEmail', type: T.STRING, required: false, nullable: true, maxLength: 254 },
		{ name: 'email', type: T.STRING, required: false, nullable: true, maxLength: 254 },
		{ name: 'mobile', type: T.STRING, required: false, nullable: true, maxLength: 32 },
		{ name: 'marketingConsentEmail', type: T.BOOLEAN, required: false, nullable: true, maxLength: null },
		{ name: 'marketingConsentSms', type: T.BOOLEAN, required: false, nullable: true, maxLength: null },
		{ name: 'marketingConsentWhatsapp', type: T.BOOLEAN, required: false, nullable: true, maxLength: null },
		{ name: 'marketingConsentPhone', type: T.BOOLEAN, required: false, nullable: true, maxLength: null },
		{ name: 'active', type: T.BOOLEAN, required: true, nullable: false, maxLength: null },
	],
})
